import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';
import { FooterContentService } from '../../services/footer-content.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [RouterLink, NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './privacy-policy.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class PrivacyPolicyComponent {
  private readonly footerContent = inject(FooterContentService);
  private readonly sanitizer = inject(DomSanitizer);

  title = 'Aviso de privacidad';
  content: SafeHtml | null = null;
  loading = true;
  error = false;

  constructor() {
    this.footerContent.getLegalPage('privacy-policy').subscribe({
      next: (page) => {
        this.title = page.title;
        // El contenido proviene del CMS (usuarios autenticados).
        this.content = this.sanitizer.bypassSecurityTrustHtml(page.contentHtml);
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
